import React from "react"

import PenIcon from "../../../assets/icons/activityFieldsIcons/PenIcon"
import CalendarIcon from "../../../assets/icons/activityFieldsIcons/CalendarIcon"
import CircleCheckIcon from "../../../assets/icons/activityFieldsIcons/CircleCheckIcon"
import ProfileIcon from "../../../assets/icons/ProfileIcon"
import GearIcon from "../../../assets/icons/GearIcon"
import NumberIcon from "../../../assets/icons/activityFieldsIcons/NumberIcon"
import CalcIcon from "../../../assets/icons/CalcIcon"

const GetIcon = ({ icon, ...props }) => {
  switch (icon?.toLowerCase()) {
    case "text":
      return <PenIcon {...props} />
    case "date":
      return <CalendarIcon {...props} />
      case "range":
    case "number":
      return <NumberIcon {...props} />
    case "selection":
      return <CircleCheckIcon {...props} />
    case "peoples":
      return <ProfileIcon {...props} />
    case "calc":
      return <CalcIcon {...props} />
    
    case "default":
      return <GearIcon {...props} />
    default:
      return null
  }
}

export default function RcmpActivityIcon(props) {
  const { cType, ...oRest } = props

  return <GetIcon icon={cType} {...oRest} />
}
